import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchCreditCard } from '../../features/auth/userSlice';
import { getCardType } from '../../utils/data';
import { logos } from '../../constants/data';
import { FaCreditCard } from 'react-icons/fa';
import { addPayment } from '../../features/home/bookingSlice';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';


const AddBalance = ({show,setShow}:any) => {
    const { t,i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { creditCards, user } = useSelector((state: RootState) => state.user);
    const [balance, setBalance] = useState<number | null>(null);
    const [selectedMethod, setSelectedMethod] = useState<string>("");

    useEffect(() => {
        if (user?.id) {
            dispatch(fetchCreditCard(user.id));
        }
    }, [dispatch, user?.id]);
    const handlePayment = async (e: React.FormEvent) => {
        e.preventDefault();
        if (selectedMethod === 'online' && user?.id) {
            try {
                const res = await dispatch(addPayment({ userId: user.id, bookId: balance,type:"Hall" })).unwrap();
                if (res?.data.url) {
                    window.location.href = res.data.url;
                }
            } catch (err) {
                console.error('Online payment error:', err);
            }
        }
    };
    return (
        <Dialog open={show} onClose={() => setShow(false)} dir={i18n.language === 'ar' ? 'rtl' : 'ltr'} className="fixed inset-0 z-50 flex p-5 items-center justify-center bg-black bg-opacity-40">
            <DialogPanel className="bg-white rounded-lg p-6 w-full max-w-lg shadow-xl">
                <DialogTitle className="text-xl mb-4 font-semibold">{t("addBalance")}</DialogTitle>

                <form onSubmit={handlePayment} className="space-y-4">
                    {/* Balance Input */}
                    <div className="flex flex-col gap-2">
                        <label htmlFor="balance">{t("balance")}</label>
                        <input
                            name="balance"
                            type="number"
                            value={balance ?? ""}
                            placeholder={t("desired-balance")}
                            onChange={(e) => {
                                const val = e.target.value;
                                if (val === "") {
                                    setBalance(null);
                                } else if (val.length <= 7) {
                                    setBalance(Number(val));
                                }
                            }}
                            className="w-full rounded-lg border border-textSecond focus:outline-primary placeholder:text-textSecond p-3"
                        />
                    </div>

                    {/* Payment Methods */}
                    <div className="flex flex-col gap-2">
                        <label className="font-medium">{t("payment-method")}</label>
                        <div className="space-y-2">
                            {/* Cards */}
                            {creditCards?.length > 0 ? (
                                creditCards.map((card: any) => {
                                    const cardType = getCardType(card.cardNumber);
                                    return (
                                        <label
                                            key={card.id}
                                            className="flex items-center gap-3 border p-3 rounded-lg cursor-pointer hover:border-primary"
                                        >
                                            <input
                                                type="radio"
                                                name="payment"
                                                value={card.id}
                                                checked={selectedMethod === card.id}
                                                onChange={() => setSelectedMethod(card.id)}
                                            />
                                            {/* Card Logo */}
                                            <img src={logos[cardType]} alt={cardType} className="w-12 h-8" />

                                            <span>
                                                {card.cardNumber
                                                    ? `**** **** **** ${card.cardNumber.slice(-4)}`
                                                    : t("saved-card")}
                                            </span>
                                        </label>
                                    );
                                })
                            ) : (
                                ""
                            )}

                            {/* Online Payment Option */}
                            <label className="flex items-center gap-3 border p-3 rounded-lg cursor-pointer hover:border-primary">
                                <input
                                    type="radio"
                                    name="payment"
                                    value="online"
                                    checked={selectedMethod === "online"}
                                    onChange={() => setSelectedMethod("online")}
                                />
                                <FaCreditCard className="text-2xl text-blue-600" />
                                <span>{t('onlinePayment')}</span>
                            </label>
                        </div>
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="w-full bg-primary text-white py-3 rounded-lg  hover:bg-primary/90"
                    >
                        {t("addBalance")}
                    </button>
                </form>
            </DialogPanel>
        </Dialog>
    );
};

export default AddBalance;
